var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFruitTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-16 -16 64.00 64.00",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#f5fde9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -16,
    width: 64,
    height: 64,
    rx: 21.12,
    fill: "#024837",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#f5fde9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.3,13c0-0.2-0.9-4.3-3.8-5.6c-2.9-1.3-6.6,0.7-6.7,0.8c-0.4,0.2-0.6,0.6-0.5,1.1c0,0.2,0.9,4.3,3.8,5.6 c0.7,0.3,1.5,0.4,2.2,0.4c2.3,0,4.4-1.2,4.5-1.3C29.2,13.9,29.4,13.4,29.3,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,19.5c-2.2-3.7-2.7-8.2-1.5-12.4C19.5,5.8,22.1,5,25,5c0.6,0,1-0.4,1-1s-0.4-1-1-1C16.4,3,9.3,9,7.5,17 C4.1,17.2,2,19.1,2,22c0,3.3,2.7,6,6,6s6-2.7,6-6c0-2.6-1.7-4.4-4.5-4.9c0.8-3.3,2.7-6.2,5.2-8.4c-0.6,4.1,0.2,8.3,2.3,11.9 c-2.1,1.8-2.5,4.3-1.1,6.4c0.8,1.3,2.2,2.3,3.7,2.7c0.5,0.1,0.9,0.2,1.4,0.2c1.1,0,2.1-0.3,3.1-0.9c2.7-1.7,3.5-5.4,1.8-8.2 C24.3,18.4,21.5,18,18.7,19.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruitTreeIcon);
export default __webpack_public_path__ + "static/media/fruit-tree-icon.0dbb8b0a57ab68531e3263c1c01fbd29.svg";
export { ForwardRef as ReactComponent };